// IMPORTANT: We use direct string manipulation instead of date-fns or other date
// libraries to avoid timezone conversion issues. Flight times must be displayed
// in their original local time, not adjusted to the user's timezone.

/**
 * Formata a data de um voo mantendo o timezone original
 * @param isoDateTimeString String de data/hora em formato ISO
 * @returns Data formatada (dd/MM/yyyy)
 */
export function formatFlightDate(isoDateTimeString?: string): string {
  if (!isoDateTimeString) return '';
  
  try {
    // Extrai apenas a parte da data (antes do 'T') e formata diretamente
    const datePart = isoDateTimeString.split('T')[0];
    if (!datePart) return '';
    
    // Converte de YYYY-MM-DD para DD/MM/YYYY
    const [year, month, day] = datePart.split('-');
    if (!year || !month || !day) return '';
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error('Erro ao formatar data de voo:', error);
    return '';
  }
}

/**
 * Formata a hora de um voo mantendo o timezone original
 * @param isoDateTimeString String de data/hora em formato ISO
 * @returns Hora formatada (HH:mm)
 */
export function formatFlightTime(isoDateTimeString?: string): string {
  if (!isoDateTimeString) return '';
  
  try {
    // Extrai apenas a parte da hora (depois do 'T')
    const timePart = isoDateTimeString.split('T')[1];
    if (!timePart) return '';
    
    // Pega apenas horas e minutos (HH:mm)
    return timePart.substring(0, 5);
  } catch (error) {
    console.error('Erro ao formatar hora de voo:', error);
    return '';
  }
}

/**
 * Formata a data e hora de um voo mantendo o timezone original
 * @param isoDateTimeString String de data/hora em formato ISO
 * @returns Data e hora formatadas (dd/MM/yyyy às HH:mm)
 */
export function formatFlightFullDateTime(isoDateTimeString?: string): string {
  if (!isoDateTimeString) return '';
  
  try {
    const date = formatFlightDate(isoDateTimeString);
    const time = formatFlightTime(isoDateTimeString);
    
    if (!date || !time) return '';
    return `${date} às ${time}`;
  } catch (error) {
    console.error('Erro ao formatar data e hora de voo:', error);
    return '';
  }
}

/**
 * Função para obter as informações enriquecidas de data e hora para um evento de voo
 * @param departureDateTime Data e hora da partida em formato ISO
 * @param arrivalDateTime Data e hora da chegada em formato ISO
 * @returns Objeto com informações formatadas para exibição
 */
export function getEnrichedFlightEventDateTime(
  departureDateTime?: string,
  arrivalDateTime?: string
) {
  return {
    departureDate: formatFlightDate(departureDateTime),
    departureTime: formatFlightTime(departureDateTime),
    arrivalDate: formatFlightDate(arrivalDateTime),
    arrivalTime: formatFlightTime(arrivalDateTime),
    departureFull: formatFlightFullDateTime(departureDateTime),
    arrivalFull: formatFlightFullDateTime(arrivalDateTime)
  };
} 